import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0032',
    ecrans: ['00-2'],
    params:['?daccleint','?refcleint', '?isforage']
});

